export const FETCH_INVOICE_REQUEST = 'INVOICE/FETCH/REQUEST';
export const FETCH_INVOICE_SUCCESS = 'INVOICE/FETCH/SUCCESS';
export const FETCH_INVOICE_FAILURE = 'INVOICE/FETCH/FAILURE';

export const OPEN_INVOICE_MODAL = 'INVOICE/MODAL/OPEN';
export const CLOSE_INVOICE_MODAL = 'INVOICE/MODAL/CLOSE';

export const IMPORT_INVOICE_REQUEST = 'INVOICE/IMPORT/REQUEST';
export const IMPORT_INVOICE_SUCCESS = 'INVOICE/IMPORT/SUCCESS';
export const IMPORT_INVOICE_FAILURE = 'INVOICE/IMPORT/FAILURE';

// FILTERS
export const SET_INVOICE_FILTER = 'INVOICES/FILTERS/SET_ONE';
export const SET_INVOICE_FILTERS = 'INVOICES/FILTERS/SET_MANY';
export const REMOVE_INVOICE_FILTER = 'INVOICES/FILTERS/REMOVE_ONE';
export const CLEAR_INVOICE_FILTERS = 'INVOICES/FILTERS/CLEAR';
